@if (content) {
  <div class="bg-gray-light p-l-20 p-r-15 p-t-30 brd-20" fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="title">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="7px">
        <div class="text-14 f-w-700 m-b-0 p-b-5">{{ content.title }}</div>
        <div fxLayoutAlign="start center" fxLayoutGap="7px">
          @for (badge of content.badges; track badge) {
            <div class="bg-chip-xs bg-gray-da">{{ badge }}</div>
          }
        </div>
      </div>
      @if (content.items.length > 0) {
        <button mat-icon-button (click)="panel.toggle()" fxFlexAlign="center">
          <mat-icon class="c-black">{{ panel.expanded ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
        </button>
      }
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between center" class="p-b-25">
      <div class="text-15 f-w-750">{{ content.value }}</div>
      <div class="text-14 f-w-600">{{ content.subValue }}</div>
    </div>

    <mat-accordion>
      <mat-expansion-panel #panel class="shadow-box-none border-none bg-gray-light p-t-10">
        @for (item of content.items; track item) {
          <div fxLayout="row" fxLayoutAlign="space-between start" class="p-b-5">
            <div>{{ item.name }}</div>
            <div class="f-w-600">{{ item.value }}</div>
          </div>
        }

        <div class="p-v-25 f-13 f-w-600">{{ content.explain }}</div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <ng-content></ng-content>

}
